module.exports = __webpack_public_path__ + "static/media/kh.61a4b374.svg";